import { render } from "./ReferralsItem.vue?vue&type=template&id=2a22f19c&scoped=true"
import script from "./ReferralsItem.vue?vue&type=script&lang=js"
export * from "./ReferralsItem.vue?vue&type=script&lang=js"

import "./ReferralsItem.vue?vue&type=style&index=0&id=2a22f19c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a22f19c"]])

export default __exports__